import withStyles from "@material-ui/core/styles/withStyles";
import { setPreview as setPreviewAction } from "Actions/commonAction";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Grid from "@material-ui/core/Grid";
import interestIcon from "Assets/Svg/interest-con.svg";
import "Module/Subscription/Recruit/index.scss";
import departmentIcon from "Assets/newicons/attribute/department/outline/department-outline-16px.svg";
import locationIcon from "Assets/newicons/user-interface/location/outline/location-outline-16px.svg";
import SearchSq from "Component/Material-ui/SearchSq";
import { multiselectinputconverter } from "Component/DynamicForm/Fields/MultiSelect";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import DynamicForm from "Component/DynamicForm";
import Paper from "@material-ui/core/Paper";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

class OpenPositions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      openPositions: [
        {
          title: "Senior frontend developer",
          productname: "product",
          location: 500,
        },
      ],
      selectedLoc: [],
      OfficeLocationList: [],
      productid: "",
      products: [],
    };
    this.handleTabChange = this.handleTabChange.bind(this);
    this.gotoApplication = this.gotoApplication.bind(this);
  }

  handleChange = (event, value, id) => {
    this.setState({ value, id }, () => {});
  };

  gotoApplication() {
    this.props.openApplication();
  }

  handleTabChange(value) {
    this.setState({
      value,
    });
  }

  selecteChange(items, name) {
    this.setState({
      [name]: items || [],
    });
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const { value } = this.state;
    return (
      <div
        id="openposition"
        style={{ marginBottom: 64, width: "80%", margin: "0 auto" }}
      >
        <Grid container spacing={3} className="thumbnails">
          <Grid item xs={12} md={3} sm={12}>
            <p
              className="large-text-dark-secondary t-bold"
              style={{ fontSize: 22 }}
            >
              Open Positions
            </p>
          </Grid>
          <Grid item xs={12} md={3} sm={12}>
            <SearchSq
              placeholder="Search letters"
              value={this.state.searchValue}
              onChange={this.searchLetter}
            />
          </Grid>
          <Grid item xs={12} md={3} sm={12}>
            <DynamicForm
              fields={multiselectinputconverter({
                value: this.state.selectedLoc,
                options: this.state.OfficeLocationList,
                placeholder: "All locations",
                idonly: true,
                label: "",
              })}
              onChange={(selectedids) => {
                this.selecteChange(selectedids, "selectedLoc");
              }}
            />
          </Grid>
          <Grid item xs={12} md={3} sm={12}>
            <DynamicForm
              fields={selectinputconverter({
                value: this.state.productid,
                placeholder: "Product",
                label: "",
                options: this.state.products,
              })}
              onChange={(selectedids) => {
                this.selecteChange(selectedids, "productid");
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          className="thumbnails margin-top-16"
          style={
            this.state.openPositions.length < 2
              ? { justifyContent: "flex-start" }
              : { justifyContent: "center" }
          }
        >
          {this.state.openPositions.map((position) => (
            <Grid
              item
              xs={12}
              md={6}
              sm={12}
              onClick={this.props.openApplication}
            >
              <Paper className="rounded-rectangle-paper padding16 cursor-pointer">
                <p className="normal-dark-secondary t-bold margin-bottom-8">
                  {position.title}
                </p>
                <div className="margin-bottom-8">
                  <img
                    src={departmentIcon}
                    className="margin-right-8 vertical-middle"
                  ></img>
                  <p
                    className="small-dark-secondary margin-bottom-8"
                    style={{ display: "inline" }}
                  >
                    {position.productname}
                  </p>
                </div>
                <div>
                  <img
                    src={locationIcon}
                    className="margin-right-8 vertical-middle"
                  ></img>
                  <p
                    className="small-dark-secondary margin-bottom-8"
                    style={{ display: "inline" }}
                  >
                    {position.productname}
                  </p>
                </div>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(OpenPositions)));
